import script from "./Banner.vue?vue&type=script&setup=true&lang=js"
export * from "./Banner.vue?vue&type=script&setup=true&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=10216623&scoped=true&lang=scss"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10216623"]])

export default __exports__